import { useEffect, useState } from "react";

import { Accordion } from "react-bootstrap";
import { DeleteSettings, GetAllSettings, GetAllTenants, SaveSettings, UpdateSettings, getAllArea } from "../../../../services/CommonService";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { ToastContainer, toast } from "react-toastify";
import { MultiSelect } from "react-multi-select-component";

const Settings = () => {
    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ size: [] }],
            [{ font: [] }],
            [{ align: ["right", "center", "justify"] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "image"],
            [{ color: ["red", "#785412"] }],
            [{ background: ["red", "#785412"] }]
        ]
    };

    const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "link",
        "color",
        "image",
        "background",
        "align",
        "size",
        "font"
    ];
    const [percent, setPercent] = useState(50);
    const [tenantlist, setTenantList] = useState([]);
    const [tenantid, setTenantId] = useState(null);
    const [actiontype, setActionType] = useState(null);
    const [value, setValue] = useState('');
    const [id, setId] = useState(null);
    const [areaList, setAreaList] = useState([])
    const [college, setCollege] = useState([])
    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };
    useEffect(() => {
        getalltenants();


    }, []);

    const handleProcedureContentChange = (content, delta, source, editor) => {
        setValue(content);
        //let has_attribues = delta.ops[1].attributes || "";
        //console.log(has_attribues);
        //const cursorPosition = e.quill.getSelection().index;
        // this.quill.insertText(cursorPosition, "★");
        //this.quill.setSelection(cursorPosition + 1);
    };


    const getalltenants = async () => {
        const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
        if (constuserdetails.roles[0] == 'ROLE_ADMIN') {


            const Response = await GetAllTenants({ pageno: -1, status: 'Active' })
            setTenantList(Response.data);
        } else {
            const Response = await GetAllTenants({ pageno: -1, status: 'Active', query: { tenantid: constuserdetails.user.tenantid } })
            setTenantList(Response.data);
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name == 'tenantid') {

            setTenantId(value);
            getAreas(value)
        } else {

            setActionType(value);
            getData(value);
        }
    }

    const getData = async (actiontype) => {
        console.log("tenantid--", tenantid);
        console.log(actiontype);
        const reqdata = {
            pageno: '-1',
            query: { tenantid: tenantid, actiontype: actiontype }
        }

        const Respdata = await GetAllSettings(reqdata);
        if (Respdata.data.length > 0) {
            console.log(Respdata.data.content);
            setValue(Respdata.data[0].content);
            setId(Respdata.data[0].id);
        }

        else {
            setValue('')
            setId('')
        }

    }

    const submitForm = async () => {

        const reqdata = {
            tenantid: tenantid,
            actiontype: actiontype,
            content: value,
            area: college
        }

        if (id == '') {
            const Response = await SaveSettings(reqdata);
            if (Response.data.id) {
                notifyTopFullWidth("Data saved successfully");
                setValue('');
                setTenantId('');
                setActionType('');
                setCollege([])

            }
        }
        else {
            reqdata.id = id;
            const Response = await UpdateSettings(reqdata);
            if (Response.data.id) {
                notifyTopFullWidth("Data updated successfully");
                setValue('');
                setTenantId('');
                setActionType('');
                setCollege([])
            }
        }

    }
    const deleteForm = async () => {
        const reqdata = {
            tenantid: tenantid,
            actiontype: actiontype,
            content: value
        }
        if (id == '') {
            const Response = await DeleteSettings(reqdata);
            if (Response.data.id) {
                notifyTopFullWidth("Data deleted successfully");
                setValue('');
                setTenantId('');
                setActionType('');

            }
        }

        if (reqdata.id = id) {
            const Response = await DeleteSettings(reqdata);
            console.log("helooooo", Response);
            if (Response.data.id) {
                notifyTopFullWidth("Data deleted successfully");
                setValue('');
                setTenantId('');
                setActionType('');
            }
        }

    }

    const getAreas = async (value) => {

        const reqdata = {
            pageno: '-1',
            query: {
                status: 'Active',
                tenantid: value,
            }
        }


        const Response = await getAllArea(reqdata)
        let counter = 0;
        const rowdata = [];
        await Response.data.reduce(async (promise, res) => {
            await promise;
            const opts = {
                label: res.name,
                value: res.id
            }
            rowdata.push(opts);
            if (counter == Response.data.length - 1) {

                setAreaList(rowdata)
            }
            counter++;
        }, Promise.resolve());

    }


    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Tenant
                </label>
                <div className="col-lg-6">
                    <select className="form-control" name="tenantid"
                        value={tenantid} onChange={handleChange}>
                        <option value=''>Select Tenant</option>
                        {tenantlist.map(item => (
                            <option
                                key={item.tenantid}
                                value={item.tenantid}
                            >
                                {item.name}
                            </option>
                        ))}
                    </select>

                </div>
            </div>


            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    College
                </label>
                <div className="col-lg-6">
                    <MultiSelect
                        options={areaList}
                        value={college}
                        onChange={setCollege}
                        labelledBy="Select"
                    />

                </div>
            </div>

            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Type
                </label>
                <div className="col-lg-6">
                    <select
                        defaultValue={"option"}
                        className="form-control"
                        id="sel1" name="actiontype" value={actiontype}
                        onChange={handleChange}
                    >
                        <option value="">Select </option>
                        <option value="About Us">About Us </option>
                        <option value="Terms">Terms & Conditions</option>
                        <option value="Privacy Policy">Privacy Policy</option>
                        <option value="Refund & Cancellation Policy">Refund & Cancellation Policy</option>

                        <option value="About Constituency">About Constituency</option>

                        <option value="About Leader">About Leader</option>

                    </select>
                </div>

            </div>

            <Accordion className="accordion accordion-danger-solid" defaultActiveKey="0">
                <Accordion.Item key={percent} eventKey={`${percent}`}>
                    <Accordion.Header className="accordion-header">
                        Add  Content
                    </Accordion.Header>
                    <Accordion.Collapse eventKey={`${percent}`} className="accordion__body">
                        <div className="accordion-body">
                            <ReactQuill
                                theme="snow"
                                modules={modules}
                                formats={formats}
                                value={value}
                                onChange={handleProcedureContentChange}
                            />
                        </div>
                    </Accordion.Collapse>
                </Accordion.Item>
            </Accordion>





            <br />


            <div className="form-group savebtn ">
                <button onClick={submitForm} className="btn btn-primary" type="button"
                >Save</button>
            </div>

            <div className="form-group savebtn">
                <button onClick={deleteForm} className="btn btn-primary" type="button"
                >Clear</button>
            </div>
        </>
    )

}
export default Settings